import React from "react";
import PropTypes from "prop-types";

import { rankLabelsBSchools } from "../../../../constants";

import "./table-view.m.css";

export const TableView = ({ bestBSchools, visibleItemsForList, columns, currentView, trackClick }) => {
  const visibleItems = ["city", "zone"].includes(currentView) ? bestBSchools.length : visibleItemsForList;

  const firstHeader = () => {
    return rankLabelsBSchools[currentView] || "";
  };

  return (
    <div styleName={`tableContainer ${currentView}-table`}>
      <table styleName="table">
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index} styleName={`table-header ${column.value}`}>
                {index === 0 ? firstHeader() : column.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {bestBSchools.slice(0, visibleItems).map((entityData, index) => (
            <tr key={index}>
              {columns.map((c, key) => (
                <td 
                  key={`${index - key}`} 
                  styleName={`cell ${c.value}`}
                  {...(c.value === "name" && {
                    onMouseDown: () => trackClick && trackClick(entityData, "list")
                  })}
                >
                  {c.value === "institution_type" && entityData["institution_type"] === "Government"
                    ? "Govt"
                    : entityData[c.value] || "N/A"}
                  <span>{c.value === "name" && currentView === "overall" ? entityData["city"] : ""}</span>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

TableView.propTypes = {
  bestBSchools: PropTypes.array.isRequired,
  visibleItemsForList: PropTypes.number.isRequired,
  columns: PropTypes.array,
  currentView: PropTypes.string,
  trackClick: PropTypes.func,
};
